// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"payRates__msignaturepad___Wfh9X","m-signature-pad--body":"payRates__m-signature-pad--body___1wFL6","m-signature-pad--footer":"payRates__m-signature-pad--footer___2xTSP","description":"payRates__description___3A2TB","button":"payRates__button___2wDg3","clear":"payRates__clear___2mi0m","save":"payRates__save___32duc","m-signature-pad":"payRates__m-signature-pad___VzB34","github":"payRates__github___26iI8","payRateContainer":"payRates__payRateContainer___12BVT"};


//////////////////
// WEBPACK FOOTER
// ./client/app/screens/main/screens/estimators/components/payRates.scss
// module id = mI0T
// module chunks = client